import React from 'react';
import { isEmpty } from 'lodash';
import SvgIcon from '../../common/SvgIcon';
import { ToolTipComponent } from '../../common/ToolTipComponent';

export const AdditionalValue = ({ balance, displayText, children }) =>
  !isEmpty(balance) ? (
    <dl>
      <dt className="account-summary__more__balances__title">
        <ToolTipComponent
          hasSvg={true}
          trigger="manual"
          childComponent={
            <SvgIcon
              id="icon-Information"
              width="20px"
              height="20px"
              className="account-summary__more__balances__title__icon"
            />
          }
          placement="bottom"
          popoverChildComponent={children}
          scope={this}
        />
        {displayText}
      </dt>
      <dd>{balance}</dd>
    </dl>
  ) : null;
